'Attachment'.datatype()
'datatype'.field({caption: 'Document Type'})
'theParentId'.field({numeric: true, indexed: true})
'parentReference'.field({caption: 'Reference'})
'attachmentType'.field({caption: 'Type'})
'description'.field()
'attachedDate'.field({date: true})
'contents'.field({caption: "Attachment File", file: true})
'fileName'.field()
'entityName'.field()
'documentType'.field()
'customerId'.field({numeric: true})

'documentType'.calculate(async attachment => {
  let datatype = attachment.datatype; if ( ! datatype ) return ''
  let cast = await datatype.bringSingle({id: attachment.theParentId}); if ( ! cast ) return ''
  return cast.datatypeCaption()
})

'attachmentType'.options(['Proforma', 'Invoice', 'Customs', 'Bill', 'Transport', 'Serial Numbers', 'Other'])

'attachmentType'.inception('Other')

'attachedDate'.inception(async attachment => {
  return global.todayYMD()
})

'parentReference'.calculate(async attachment => {
  let datatype = attachment.datatype; if ( ! datatype ) return ''
  let cast = await datatype.bringSingle({id: attachment.theParentId}); if ( ! cast ) return ''
  return cast.keyValue()
})

'Attachment'.method('toParent', async function() {
  let datatype = this.datatype; if ( ! datatype ) return
  let res = await datatype.bringFirst({id: this.theParentId})
  return res
})

'parentReference'.destination(async attachment => {
  return await attachment.toParent()
})

'Attachment'.beforeSaving(async function() {
  if ( ! this.contents )
    throw(new Error('Please choose a file to upload'))
})

'Attachment'.method('toAttachmentsSubfolderOnServer', function() {

  let sanitizeEntityName = name => {
    return name.replace(/[/\\?%*:|"<>]/g, '-');
  }

  let res = ''
  let entityName = this.entityName
  if ( entityName ) {
    entityName = sanitizeEntityName(entityName)
    res = entityName
  }
  if ( this.parentReference ) {
    if ( res )
      res += '/'
    res = res + this.parentReference
  }
  return res
})
